export const ImageProcessingEngineVersion = 37;
export const DoSmallDetailsPart = true;
export const ShowAIPreviewOption = true;
